<template>
	<section class="row notice popover-target-wrapper payment-notice" :class="{secondary: card || trial || loading, error:card && card.expired, warning:!trial && !card}">

		<spinner v-if="loading"></spinner>

		<div class="row flexible" v-else>
			<div class="flexible">
				<span v-if="card">
					<span v-if="trial">
						<i class="fab" :class="'fa-cc-' + card.brand.toLowerCase()"></i>
						<strong>{{card.last4}}</strong> billed after trial
					</span>
					<span v-else-if="card.expired">
						<i class="fab" :class="'fa-cc-' + card.brand.toLowerCase()"></i>
						<strong>{{card.last4}}</strong> expired
					</span>
					<span v-else>
						Billed to
						<i class="fab" :class="'fa-cc-' + card.brand.toLowerCase()"></i>
						<strong>{{card.last4}}</strong>
					</span>
				</span>
				<span v-else>
					<span v-if="trial">No payment method</span>
					<span v-else>Payment required</span>

					<popover
						class="right"
						:message="trial ? 'To continue service after your trial, please enter a payment method.' : 'A payment method is required to subscribe to this plan.'">
						<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
					</popover>
				</span>
			</div>

			<footer class="rigid separated">
				<!-- provide link destination -->
				<router-link v-if="returnPath" class="centered" @click.native="onLinkClick()" :to="linkDestination">
					<span v-if="card && card.expired">Update</span>
					<span v-else-if="card">Change</span>
					<span v-else>Add Card</span>
				</router-link>
				<!-- add function to call -->
				<button v-else @click="onLinkClick()" class="link">
					Change
				</button>
			</footer>
		</div>
	</section>
</template>

<script>
import Popover from './Popover.vue';
import Spinner from './Spinner.vue';

export default {
	name: 'PaymentNotice',
	components:{
		Popover,
		Spinner
	},
	props: {
		model: Object,
		toUrl: String,
		returnPath: String,
		trial: Boolean,
		onClick: Function,
		isDirty: Boolean,
		loading: Boolean
	},
	data() {
		return {
			card: this.model || null,
		};
	},
	computed:{
		linkDestination() {
			return this.toUrl || '/payments/method?returnPath=' + this.returnPath;
		}
	},
	watch: {
		model(val, old) {
			this.card = val;
		},
		selection(val, old) {
			this.selection = val;
		}
	},
	methods:{
		onLinkClick() {
			if (typeof this.onClick === 'function') {
				this.onClick();
			}
		}
	}
};
</script>

<style scoped>
	.loading {
		padding: 0;
		margin: auto;
	}

	.popover-target-wrapper > .row.gap {
		position: static;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/PaymentNotice.vue